export const INIT_BUYCART = 'INIT_BUYCART'
export const ADD_CART = 'ADD_CART'
export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const ADD_ANIMATION = 'ADD_ANIMATION'
export const SHOW_CART = 'SHOW_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
export const SET_CATEGORYLIST = 'SET_CATEGORYLIST'
export const CLEAR_CART = 'CLEAR_CART'
export const SET_COMPANYID = 'SET_COMPANYID'
export const SET_COMPANYINFO = 'SET_COMPANYINFO'
export const SET_HOST = 'SET_HOST'
export const SET_SHOWZK = 'SET_SHOWZK'
export const SET_ADDBYBAG = 'SET_ADDBYBAG'
export const SET_COMPUTEDZK = 'SET_COMPUTEDZK'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js